module.exports = __webpack_public_path__ + "media/images/mobile/solutions/20-e07ed9c29d50ab50585b0182a4076392.png";